import { cn } from "@/lib/utils";
import * as React from "react";

interface InputProps extends React.ComponentProps<"textarea"> {
  pre?: React.ReactNode;
  preProps?: React.ComponentProps<"span">;
  post?: React.ReactNode;
  postProps?: React.ComponentProps<"span">;
  wrapperProps?: React.ComponentProps<"div">;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, InputProps>(
  (
    { pre, post, preProps, postProps, wrapperProps, className, ...props },
    ref
  ) => {
    return (
      <div
        {...wrapperProps}
        className={cn(
          "input-wrapper flex items-center rounded-sm border-1 border-input bg-transparent shadow-none transition-colors focus-within:ring-2 focus-within:ring-primary",
          wrapperProps?.className,
          {
            "pointer-events-none !bg-neutral-100": props?.disabled,
            "ring-1 !ring-destructive": props["aria-invalid"],
          }
        )}
      >
        {pre && (
          <span
            {...preProps}
            className={cn(
              "flex items-center pl-3 text-muted-foreground",
              preProps?.className,
              {
                "pointer-events-none": props?.disabled,
              }
            )}
          >
            {pre}
          </span>
        )}
        <textarea
          className={cn(
            "flex-1 border-0 rounded-sm bg-transparent px-3 py-1 text-base focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
            className,
            {
              "pointer-events-none": props?.disabled,
            }
          )}
          ref={ref}
          {...props}
          rows={props.rows ?? 4}
        />
        {post && (
          <span
            {...postProps}
            className={cn(
              "flex items-center pr-3 text-muted-foreground",
              postProps?.className,
              {
                "pointer-events-none": props?.disabled,
              }
            )}
          >
            {post}
          </span>
        )}
      </div>
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
